import { render, staticRenderFns } from "./NotificationsRoot.vue?vue&type=template&id=0848fdcd&scoped=true"
import script from "./NotificationsRoot.vue?vue&type=script&lang=js"
export * from "./NotificationsRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0848fdcd",
  null
  
)

export default component.exports